


































































































































































































































































































































































import { DataParse } from "@wj/common";
import { Vue, Component, Watch } from "vue-property-decorator";
import {
  normalReq,
  summarygReq,
  recruitmentForm,
  costForm,
  communicationForm,
  dataAnalysisForm,
} from "@/common/class/scheduleManagement/scheduleSummary/index";
import {
  getCommunicationList,
  getSummaryList,
  getEcahrtsList,
  getRecruitList,
  getFeeList,
  CommunicationInsert,
  CommunicationDelete,
  CommunicationEdit,
  getAnalyze,
  RecruitInsert,
  RecruitUpdate,
  FeeUpdate,
  FeeInsert,
} from "@/api/scheduleManagement/scheduleSummary/index";
import myLoading from "@/components/global/my-loading/index.vue";
import majorDistribution from "@/views/page/scheduleManagement/BookingSituation/echarts/majorDistribution/index.vue";
import filters from "@/common/filter/config/filter";
import * as echart from "echarts";
import { set } from "vue/types/umd";
require("echarts/map/js/china");
require("echarts/extension/bmap/bmap");

interface nameTest {
  majorDescribe: string;
}
@Component({
  components: {
    myLoading,
    majorDistribution,
  },
})
export default class empowermentQueryComponent extends Vue {
  isRequest = false;
  req = new summarygReq();
  normalReq = new normalReq();
  recruitmentForm = new recruitmentForm();
  costForm = new costForm();
  dataAnalysisForm = new dataAnalysisForm();
  communicationForm = new communicationForm();
  communicationFormArr: Array<communicationForm> = [];
  echartsData: Array<any> = [];
  tableloading = false;
  divloading1 = false;
  divloading2 = false;
  divloading3 = false;
  divloading4 = false;
  scheduleDialogloading = false;
  itemExecuteState = "";
  //当前选中行程id
  currentItineraryId = "";
  scheduleDialogVisible = false;
  RecruitAddorupdate = false;
  FeeAddorupdate = false;
  tableData = new DataParse();
  Height = 250;
  //费用单次合计
  costTotal: number = 0;

  created() {
    this.getList();
    
    
  }

  mounted() {
    this.getHeight();
    window.addEventListener("resize", this.getHeight, false);
  }
  async init(){
   await this.getList();
  }

  getHeight() {
    //获取浏览器高度并计算得到表格所用高度。
    this.$nextTick(() => {
      this.Height = document.documentElement.clientHeight - 120;
    });
  }
  goDetail(data: any) {
    console.log(data);
    this.scheduleDialogVisible = true;
    this.recruitmentForm = new recruitmentForm();
    this.costForm = new costForm();
    this.dataAnalysisForm = new dataAnalysisForm();
    this.communicationForm = new communicationForm();
    this.communicationFormArr = [];
    this.costTotal = 0;
    this.itemExecuteState = data.executeState;
    this.currentItineraryId = data.id;
    this.recruitmentForm.interviewPassNumber = data.passNumber;
    this.recruitmentForm.checkinNumber = data.checkinNumber;
    this.recruitmentForm.speechTime = data.speechTime;
    this.recruitmentForm.university = data.university;
    this.recruitmentForm.address = data.address;
    this.getCommunication(data.id);
    this.getRecruit(data.id);
    this.getFee(data.id);
  }
  getecharts(id: any) {
    this.scheduleDialogloading = true;
    let param = { id: id };
    getEcahrtsList(param)
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.tableData.listItem = data.rows;
          this.tableData.total = data.total;
          this.tableData.getNo(this.req.pageNo, this.req.pageSize);
        }
      })
      .finally(() => {
        this.scheduleDialogloading = false;
      });
  }

  // 查询
  onSubmit() {
    this.req.pageNo = 1;
    this.getList();
  }

  // 重置
  reSubmit() {
    this.req = new summarygReq();
    this.getList();
  }

  // 获取列表
  getList() {
    this.tableloading = true;
    this.req.executeState = "2";
    getSummaryList(this.req)
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.tableData.listItem = data.rows;
          this.tableData.total = data.total;
          this.tableData.getNo(this.req.pageNo, this.req.pageSize);
        }
      })
      .finally(() => {
        this.tableloading = false;
      });
  }
  // 获取招聘情况
  getRecruit(id: any) {
    this.divloading1 = true;
    this.normalReq.itineraryId = id;
    getRecruitList(this.normalReq)
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.RecruitAddorupdate = data.total != 0 ? true : false;
          if (data.rows.length > 0) {
            this.recruitmentForm = data.rows[0];
            this.goAnalyse();
          }
        } else {
        }
      })
      .finally(() => {
        this.divloading1 = false;
      });
  }
  //招聘情况新增
  addSubmit(formName: string) {
    (this.$refs[formName] as HTMLFormElement).validate((valid: any) => {
      if (valid) {
        this.divloading1 = true;
        this.recruitmentForm.itineraryId = this.currentItineraryId;
        this.recruitmentForm.speechTime = filters.dateFormat(
          this.recruitmentForm.speechTime
        );
        RecruitInsert(this.recruitmentForm)
          .then((res) => {
            const { success, data, messgae } = res;
            if (success) {
              this.$message({
                message: "新增成功",
                type: "success",
              });
              this.recruitmentForm = new recruitmentForm();
              this.getRecruit(this.currentItineraryId);
            } else {
              this.$message({
                message: "新增失败",
                type: "error",
              });
            }
          })
          .finally(() => {
            this.divloading1 = false;
          });
      }
    });
  }
  //招聘情况编辑
  updateSubmit(formName: string) {
    (this.$refs[formName] as HTMLFormElement).validate((valid: any) => {
      if (valid) {
        this.divloading1 = true;
        this.recruitmentForm.itineraryId = this.currentItineraryId;
        this.recruitmentForm.speechTime = filters.dateFormat(
          this.recruitmentForm.speechTime
        );
        RecruitUpdate(this.recruitmentForm)
          .then((res) => {
            const { success, data, messgae } = res;
            if (success) {
              this.$message({
                message: "编辑成功",
                type: "success",
              });
              this.recruitmentForm = new recruitmentForm();
              this.getRecruit(this.currentItineraryId);
            } else {
              this.$message({
                message: "编辑失败",
                type: "error",
              });
            }
          })
          .finally(() => {
            this.divloading1 = false;
          });
      }
    });
  }

  // 获取交流情况
  getCommunication(id: any) {
    this.divloading2 = true;
    this.normalReq.itineraryId = id;
    getCommunicationList(this.normalReq)
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.communicationFormArr = data.rows;
        }
      })
      .finally(() => {
        this.divloading2 = false;
      });
  }
  // 新增交流情况
  insertCommunication(formName: string) {
    (this.$refs[formName] as HTMLFormElement).validate((valid: any) => {
      if (valid) {
        this.divloading2 = true;
        this.communicationForm.itineraryId = this.currentItineraryId;
        CommunicationInsert(this.communicationForm)
          .then((res) => {
            const { success, data, messgae } = res;
            if (success) {
              this.$message({
                message: "新增成功",
                type: "success",
              });
              this.getCommunication(this.currentItineraryId);
              this.communicationForm = new communicationForm();
            } else {
              this.$message({
                message: "新增失败",
                type: "error",
              });
            }
          })
          .finally(() => {
            this.divloading2 = false;
          });
      }
    });
  }
  // 编辑交流情况
  editCommunication(key: any, formName: string) {
    (this.$refs[formName][0] as HTMLFormElement).validate((valid: any) => {
      if (valid) {
        this.divloading2 = true;
        this.communicationFormArr[key].itineraryId = this.currentItineraryId;
        CommunicationEdit(this.communicationFormArr[key])
          .then((res) => {
            const { success, data, messgae } = res;
            if (success) {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.getCommunication(this.currentItineraryId);
            } else {
              this.$message({
                message: "保存失败",
                type: "error",
              });
            }
          })
          .finally(() => {
            this.divloading2 = false;
          });
      }
    });
  }
  // 删除交流情况
  deleteItem(key: any) {
    this.divloading2 = true;
    let param = [];
    param.push(this.communicationFormArr[key].id);
    CommunicationDelete(param)
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getCommunication(this.currentItineraryId);
        } else {
          this.$message({
            message: "删除失败",
            type: "error",
          });
        }
      })
      .finally(() => {
        this.divloading2 = false;
      });
  }
  // 获取费用汇总
  getFee(id: any) {
    this.divloading3 = true;
    this.normalReq.itineraryId = id;
    getFeeList(this.normalReq)
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.FeeAddorupdate = data.total != 0 ? true : false;
          if (data.rows.length > 0) {
            this.costForm = data.rows[0];
            this.goCount();
          }
        } else {
        }
      })
      .finally(() => {
        this.divloading3 = false;
      });
  }
  //费用汇总新增
  feeAddSubmit(formName: string) {
    (this.$refs[formName] as HTMLFormElement).validate((valid: any) => {
      if (valid) {
        this.divloading3 = true;
        this.costForm.itineraryId = this.currentItineraryId;
        this.costForm.useTime = filters.dateFormat(this.costForm.useTime);
        FeeInsert(this.costForm)
          .then((res) => {
            const { success, data, messgae } = res;
            if (success) {
              this.$message({
                message: "新增成功",
                type: "success",
              });
              this.recruitmentForm = new recruitmentForm();
              this.getFee(this.currentItineraryId);
            } else {
              this.$message({
                message: "新增失败",
                type: "error",
              });
            }
          })
          .finally(() => {
            this.divloading3 = false;
          });
      }
    });
  }
  //费用汇总编辑
  feeUpdateSubmit(formName: string) {
    (this.$refs[formName] as HTMLFormElement).validate((valid: any) => {
      if (valid) {
        this.divloading3 = true;
        this.costForm.itineraryId = this.currentItineraryId;
        this.costForm.useTime = filters.dateFormat(this.costForm.useTime);
        FeeUpdate(this.costForm)
          .then((res) => {
            const { success, data, messgae } = res;
            if (success) {
              this.$message({
                message: "编辑成功",
                type: "success",
              });
              this.recruitmentForm = new recruitmentForm();
              this.getFee(this.currentItineraryId);
            } else {
              this.$message({
                message: "编辑失败",
                type: "error",
              });
            }
          })
          .finally(() => {
            this.divloading3 = false;
          });
      }
    });
  }

  //点击生成分析
  goAnalyse() {
    this.divloading4 = true;
    let param = { itId: this.currentItineraryId };
    getAnalyze(param)
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.dataAnalysisForm = data;
        }
      })
      .finally(() => {
        this.divloading4 = false;
      });
  }
  //计算单次费用合计
  goCount() {
    this.costTotal = 0;
    this.costTotal =
      (parseFloat(this.costForm.feeStall)
        ? parseFloat(this.costForm.feeStall)
        : 0) +
      (parseFloat(this.costForm.feeGift)
        ? parseFloat(this.costForm.feeGift)
        : 0) +
      (parseFloat(this.costForm.feeTraffic)
        ? parseFloat(this.costForm.feeTraffic)
        : 0) +
      (parseFloat(this.costForm.feeLodging)
        ? parseFloat(this.costForm.feeLodging)
        : 0) +
      (parseFloat(this.costForm.feeDining)
        ? parseFloat(this.costForm.feeDining)
        : 0) +
      (parseFloat(this.costForm.feePlatform)
        ? parseFloat(this.costForm.feePlatform)
        : 0) +
      (parseFloat(this.costForm.feeMaterial)
        ? parseFloat(this.costForm.feeMaterial)
        : 0);
  }
  //正整数正小数正则表达式
  validateZXS = (rule: any, value: any, callback: any) => {
    let CEN = new RegExp(/^\d+$|^\d*\.\d+$/g);
    if (!CEN.test(value)) {
      value = "";
      return callback(new Error("由数字和小数点组成"));
    } else {
      callback();
    }
  };
  rules1 = {
    speechTime: [{ required: true, message: "必填", trigger: "blur" }],
    university: [{ required: true, message: "必填", trigger: "blur" }],
    provinces: [{ required: true, message: "必填", trigger: "blur" }],
    address: [{ required: true, message: "必填", trigger: "blur" }],
    city: [{ required: true, message: "必填", trigger: "blur" }],
    speecherName: [{ required: true, message: "必填", trigger: "blur" }],
    entourage: [{ required: true, message: "必填", trigger: "blur" }],
    checkinNumber: [{ required: true, message: "必填", trigger: "blur" }],
    attendanceNumber: [{ required: true, message: "必填", trigger: "blur" }],
    resumeNumber: [{ required: true, message: "必填", trigger: "blur" }],
    interviewNumber: [{ required: true, message: "必填", trigger: "blur" }],
    interviewPassNumber: [{ required: true, message: "必填", trigger: "blur" }],
    signNumber: [{ required: true, message: "必填", trigger: "blur" }],
    registerNumber: [{ required: true, message: "必填", trigger: "blur" }],
  };
  rules2 = {
    visitorName: [{ required: true, message: "必填", trigger: "blur" }],
    teacher: [{ required: true, message: "必填", trigger: "blur" }],
    gift: [{ required: true, message: "必填", trigger: "blur" }],
    job: [{ required: true, message: "必填", trigger: "blur" }],
    contact: [{ required: true, message: "必填", trigger: "blur" }],
    office: [{ required: true, message: "必填", trigger: "blur" }],
    content: [{ required: true, message: "必填", trigger: "blur" }],
  };
  rules3 = {
    statisticsName: [{ required: true,message: "必填", trigger: "blur" }],
    users: [{ required: true,message: "必填", trigger: "blur" }],
    useTime: [{ required: true,message: "必填", trigger: "blur" }],
    reason: [{ required: true,message: "必填", trigger: "blur" }],
    feeGift: [{ required: true, validator: this.validateZXS, trigger: "blur" }],
    feeTraffic: [
      { required: true, validator: this.validateZXS, trigger: "blur" },
    ],
    feeLodging: [
      { required: true, validator: this.validateZXS, trigger: "blur" },
    ],
    feeDining: [
      { required: true, validator: this.validateZXS, trigger: "blur" },
    ],
    feePlatform: [
      { required: true, validator: this.validateZXS, trigger: "blur" },
    ],
    feeMaterial: [
      { required: true, validator: this.validateZXS, trigger: "blur" },
    ],
    singleSum: [{ required: true, trigger: "blur" }],
    feeStall: [
      { required: true, validator: this.validateZXS, trigger: "blur" },
    ],
  };

  changePage(index: number) {
    this.req.pageNo = index;
    this.getList();
  }
}
